import { FC } from 'react';

import { BiError } from 'react-icons/bi';

import { Container } from './styles';

interface IErrorContainerProps {
  readonly error: string;
}

export const ErrorContainer: FC<IErrorContainerProps> = ({ error }) => {
  return (
    <Container>
      <BiError size={60} />
      <h1>{error}</h1>
    </Container>
  );
};
